const footerLinks = {
  '快速导航': [
    { label: '热门排行榜', href: '#ranking' },
    { label: '特色优势', href: '#features' },
    { label: '精选推荐', href: '#cards' },
    { label: '常见问题', href: '#faq' },
  ],
  '内容分类': [
    { label: '日漫专区', href: '#index' },
    { label: '国漫精选', href: '#index' },
    { label: '韩漫热榜', href: '#index' },
    { label: '新番速递', href: '#updates' },
  ],
  '关于我们': [
    { label: '平台介绍', href: '#about' },
    { label: '联系投稿', href: '#contact' },
    { label: '移动端', href: '#app' },
    { label: '读者评价', href: '#comments' },
  ],
};

export default function Footer() {
  const handleClick = (href: string) => {
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer id="footer" className="bg-background-100 border-t border-background-200/70">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          <div className="col-span-2 md:col-span-1">
            <span className="text-2xl font-heading text-primary-500">51动漫网</span>
            <p className="mt-4 text-sm text-foreground-600 leading-relaxed">
              51动漫网致力于为广大动漫爱好者提供高清在线观看服务，支持日漫、韩漫、国漫全集免费追更与下拉式阅读，让您随时随地畅享动漫世界的精彩。
            </p>
          </div>

          {Object.entries(footerLinks).map(([title, links]) => (
            <div key={title}>
              <h4 className="text-sm font-medium text-foreground-950 mb-4">{title}</h4>
              <ul className="flex flex-col gap-2">
                {links.map((link) => (
                  <li key={link.label}>
                    <a
                      href={link.href}
                      onClick={(e) => { e.preventDefault(); handleClick(link.href); }}
                      className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 pt-8 border-t border-background-200/70">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-foreground-500">
              &copy; {new Date().getFullYear()} 51动漫网. 本站内容仅供学习交流，请支持正版。
            </p>
            <div className="flex items-center gap-4">
              <span className="text-xs text-foreground-500">合作伙伴</span>
              <span className="text-xs text-foreground-400">—— 虚位以待 ——</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}